import React from "react";

const Title=(props)=>{

    return(
        <h2 style={{color:" #5e5e5e",fontStyle:"italic" , fontSize:"23px"}}>{props.title}</h2>
    )
}

export default Title